import React from 'react';
import './helpers.css';

export const SpinnerMarcas = () => {
    return (
        <div className='spinner-container'>
            <div className="spinner-loader"></div>
        </div>
    )
}